// External dependencies
var $ = require('jquery')
var moment = require('moment')
var window = require('window')
var forumArticleTag = require('forumArticleTag')
var forumCategory = require('forumCategory')

var forum = {
  getArticlesTopics: function(){
    function getArticles(topicIds, callback){

      function renderArticle(article){
        var forumUrl = 'https://forum.portaldotrader.com.br'
        var post = article.posts[0].content
        var imgSrc = '/img/portal-logo-md.png'
        var forumImgSrc = null
        var cloudinaryImgSrc = null
        if( post.indexOf('<img src="') !== -1 ) {
          forumImgSrc = post.split('<img src="')[1].split('"')[0].split('/assets/uploads/files/')[1]
          cloudinaryImgSrc = 'https://res.cloudinary.com/portal-do-trader/image/upload/w_348,c_scale/pdt-artigos/' + forumImgSrc
        }
        var name = article.posts[0].user.fullname
        if (name == '') name = article.posts[0].user.username
        var teaser = post.replace(/(<([^>]+)>)/ig,'')

        var html = '<div class="col-lg-6 col-xl-4 my-3">'+
            '<div class="card rounded-0">'+
              '<a href="'+forumUrl+'/topic/'+article.slug+'" target="_blank">'+
                '<span class="card-label back-orange">Artigo</span>'+
                '<img class="card-img-top rounded-0" src="'+(cloudinaryImgSrc ? cloudinaryImgSrc : forumImgSrc) +'">'+
                '<div class="card-body">'+
                  '<h5 class="card-title">'+article.titleRaw+'</h5>'+
                  '<div class="card-text" id="article_'+article.mainPid+'">'+teaser+'</div>'+
                '</div>'+
              '</a>'+
              '<div class="d-flex justify-content-between pb-2 px-4">'+
                '<small class="text-muted">'+name+'</small><small class="text-muted">'+article.viewcount+' visitas</small>'+
              '</div>'+
            '</div>'+
          '</div>'
        $('.row-articles').append(html)
      }

      var functions=[]
      topicIds.forEach(function(tid){
        functions.push(function(i){
          $.ajax({
            url: 'https://forum.portaldotrader.com.br/api/topic/'+tid,
            type: 'GET',
            dataType: 'json',
            success: function(article){
              renderArticle(article)
              if(functions[i+1]) functions[i+1](i+1)
            }
          })
        })
      })
      functions[0](0)
    }
    $.ajax({
      url: 'https://forum.portaldotrader.com.br/api/tags/'+forumArticleTag,
      type: 'GET',
      dataType: 'json',
      success: function(articles){
        var topicIds = []
        articles.topics.forEach(function(topic){
          if(topic.cid == '21' && !topic.deleted)
          {topicIds.push(topic.tid)}
        })
        getArticles(topicIds.splice(0, 6))
      }
    })
  },
  getCategory: function(){
    function renderTopic(topic){
      var avatarImg = topic.user.picture == '' ? '<div class="forum-user-icon mr-3" style="background: '+ topic.user['icon:bgColor'] +'">'+ topic.user['icon:text']+'</div>' : '<img src="https://forum.portaldotrader.com.br' + topic.user.picture+ '" class="forum-user-img mr-3">'
      var teaser = '<div class="forum-card"><p class="m-0"> Ninguém respondeu.</p></div>'
      if(topic.teaser){
        var teaserAvatarImg = topic.teaser.user.picture == '' ? '<div class="forum-user-icon mr-2" style="background: '+ topic.teaser.user['icon:bgColor'] +'">'+ topic.teaser.user['icon:text']+'</div>' : '<img src="https://forum.portaldotrader.com.br' + topic.teaser.user.picture+ '" class="forum-user-img mr-2">'
        teaser =
          '<div class="forum-card align-self-baseline">'+
            '<a href="https://forum.portaldotrader.com.br/topic/'+topic.slug+'" target="_blank" class="color-darkgray d-block w-100">'+
              '<div class="d-flex align-items-center">'+
                  teaserAvatarImg+
                  '<span class="forum-timeago forum-timeago-card" title="">' + topic.teaser.timestamp + '</span>'+
              '</div>'+
              '<div class="forum-post-content">'+
                '<p>'+ topic.teaser.content.replace(/(<([^>]+)>)/ig,''); + '</p>'+
              '</div>'+
            '</a>'+
          '</div>'
      }
      var html =
        '<div class="row my-3">'+
          '<div class="col-10 col-lg-8 d-flex">'+
              '<div class="align-self-center">'+
                '<a href="https://forum.portaldotrader.com.br/topic/'+topic.slug+'" target="_blank" class="color-darkgray">'+
                avatarImg+
                '</a>'+
              '</div>'+
              '<h5 class="align-self-center m-0 w-100">'+
                '<a href="https://forum.portaldotrader.com.br/topic/'+topic.slug+'" target="_blank" class="color-darkgray d-block w-100">'+
                  '<strong>'+topic.titleRaw + '</strong><br>' +
                  '<small>' +
                    'Criado há <span class="forum-timeago">' + topic.timestamp + '</span> • '+ topic.user.username +
                  '</small>'+
                '</a>'+
              '</h5>'+
          '</div>'+
          '<div class="mobile-stat col-2 d-lg-none text-right">'+
            '<a href="https://forum.portaldotrader.com.br/topic/'+topic.slug+'" target="_blank" class="color-darkgray d-block w-100">'+
              '<span class="human-readable-number">'+ topic.postcount + '</span> <i class="fa fa-arrow-circle-right"></i>'+
            '</a>'+
          '</div>'+
          '<div class="col-lg-1 d-none d-lg-flex align-items-center forum-stats">'+
            '<div class="text-center">'+
              '<a href="https://forum.portaldotrader.com.br/topic/'+topic.slug+'" target="_blank" class="color-darkgray d-block w-100">'+
                '<div title="<%= topic.postcount %>">'+ topic.postcount +'</div>'+
                '<small>Posts</small>'+
              '</a>'+
            '</div>'+
          '</div>'+
          '<div class="col-lg-1 d-none d-lg-flex align-items-center forum-stats">'+
            '<div class="text-center">'+
              '<a href="https://forum.portaldotrader.com.br/topic/'+topic.slug+'" target="_blank" class="color-darkgray d-block w-100">'+
                '<div title="<%= topic.viewcount %>">'+topic.viewcount+'</div>'+
                '<small>Visitas</small>'+
              '</a>'+
            '</div>'+
          '</div>'+
          '<div class="col-lg-2 teaser d-none d-lg-flex align-items-center">'+
            teaser+
          '</div>'+
        '</div>'
      $('#forumTopics_container').append(html)
    }
    $.ajax({
      url: 'https://forum.portaldotrader.com.br/api/category/'+forumCategory,
      type: 'GET',
      dataType: 'json',
      success: function(category){
        var topics = 0
        category.topics.forEach(function(topic){
          if(!topic.deleted && topics < 8){
            topics ++
            renderTopic(topic)
          }
        })
        forum.timeAgo()
      }
    })
  },
  timeAgo: function(){
    moment.locale('pt-BR')
    $('.forum-timeago').each(function(){
      var timeago = moment ( parseFloat($(this).text()) )
      var momentStr = moment(timeago).fromNow()
      var atrasInd = momentStr.indexOf(' atrás')
      $(this).text( (atrasInd == -1 || $(this).hasClass('forum-timeago-card')) ? momentStr : momentStr.substr(0, atrasInd) )
    })
  }
}

$(window.document).ready(function(){
  if(forumArticleTag != '') forum.getArticlesTopics()
  if(forumCategory != '') forum.getCategory()
})
